import React from 'react'
import TestimonialCards from './TestimonialCards'
import Carousels from '../Carousels'
import sonia from '../../assets/testimonials/teacher/New_Project_(9).webp'
import shubham from '../../assets/testimonials/teacher/New_Project_(10).webp'
import sudeep from '../../assets/testimonials/teacher/New_Project_(14).webp'
import parul from '../../assets/testimonials/teacher/New_Project_(8).webp'
import sanjamdeepkaur from '../../assets/testimonials/teacher/New_Project_(11).webp'
import rani from '../../assets/testimonials/teacher/New_Project_(12).webp'
import soniasood from '../../assets/testimonials/teacher/New_Project1.webp'
import fariha from '../../assets/testimonials/teacher/New_Project_(5)1.webp'
function TeacherTestimonials() {
    const data = [
        {
            id: 1,
            name: "Parul Mahajan",
            content: "It is my first experience as a teacher. Worldo tutor's team has made me so comfortable and given a lot of motivation!",
            subtitle: "(Tutor)",
            expriance: "",
            image: parul
        },
        {
            id: 2,
            name: "Sonia",
            content: "I really want to appreciate all of you for being wonderful teachers, the way you interact with students, the way of teaching, making learning so interesting, and explaining everything is outstanding.",
            subtitle: "(Tutor)", 
            expriance: "",
            image: sonia
        },
        {
            id: 3,
            name: "Shabnam Mahajan",
            content: "Worldotutor is a wonderful global platform for each individual who is enthusiastic, dedicated and determined to take his teaching passion to next level of success ladder.",
            subtitle: "(Tutor)",
            expriance: "",
            image: shubham
        },
        {
            id: 4,
            name: "Sudeep Nayak", 
            content: "Nice experience to work with WorldOtutors. Amazing to see diversified learning opportunities at one platform.",
            subtitle: "(Tutor)",
            expriance: "",
            image: sudeep
        },
        {
            id: 5,
            name: "Sanjamdeepkaur",
            content: "I feel blessed to work with this association, they showed confidence in me and by god's grace I have got the classes ❤️",
            subtitle: "(Tutor)",
            expriance: "",
            image: sanjamdeepkaur
        },
        {
            id: 6,
            name: "Rani Puja",
            content: "I am working with World O Tutor as a chess coach. This is very good teaching & learning website. I would like to recommend anyone to join this.",
            subtitle: "(Tutor)",
            expriance: "",
            image: rani
        },
        {
            id: 7,
            name: "Sonia Sood",
            content: "I am honored to be a part of World O Tutors organization as it provides a platform to teachers as well as students to learn and grow.",
            subtitle: "(Tutor)",
            expriance: "",
            image: soniasood
        },
        {
            id: 8,
            name: "Fariha Alamgir",
            content: "Simi Mam is very patient and kind with her students. She is very familiar with teaching techniques. The way she teaches is very nice and understandable.",
            subtitle: "(Tutor)",
            expriance: "",
            image: fariha
        },
        {
            id: 9,
            name: "Gaurav Ghatoray",
            content: "Greetings!! This platform has helped me in more than one way. We, as teachers, have flexibility in terms of timings, students, and subjects. It has improved me in many aspects.",
            subtitle: "(Tutor)",
            expriance: "",
            image: "https://www.worldotutor.com/wtadmin/uploads/New_Project.png"
        },
        {
            id: 10,
            name: "Dr. Monika Sharma",
            content: "It's a great experience to work with WorldO Tutors. Their coordination skills are mind-blowing. They provide very effective and professional guidance.",
            subtitle: "(Tutor)",
            expriance: "",
            image: "https://www.worldotutor.com/wtadmin/uploads/New_Project_(2).png"
        }
    ]
  return (
    <div className='container mx-auto'>
    <div className='py-5  max-w-2xl mx-auto'>
          <h2 className='h1 text-center '> Why They Love Teaching at World O’ Tutors </h2>
          {/* <p className='max-w-2xl mx-auto py-4 text-center text-lg md:text-xl'> Behind every great student success story is a passionate educator. Hear directly from our dedicated tutors about how World O’ Tutors empowers them to teach, grow,
             and connect with students across the globe. </p> */}
    </div>
<div className='pt-4 '>

<Carousels>
{data.map((item: any) => (
    //   <Box key={item.id} display="flex" justifyContent="center" alignItems="stretch" height="100%">
        <TestimonialCards
         key={item.name}
          name={item.name}
          content={item.content}
          subtitle={item.subtitle}
          expriance={item.expriance}
          image={item.image}
        />
    //   </Box>
    ))}
</Carousels>
</div>
    </div>
  )}

export default TeacherTestimonials